/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ehckhYnyDHgCBbV47m9bkf
// Component: aVJYhoS8iDMR

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { Tooltip } from "../../components/plexus/Tooltip"; // plasmic-import: EBbuUzYSewBk/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_pricing.css"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/projectcss
import sty from "./PlasmicHoverableText.module.css"; // plasmic-import: aVJYhoS8iDMR/css

createPlasmicElementProxy;

export type PlasmicHoverableText__VariantMembers = {
  above: "above";
};
export type PlasmicHoverableText__VariantsArgs = {
  above?: SingleBooleanChoiceArg<"above">;
};
type VariantPropType = keyof PlasmicHoverableText__VariantsArgs;
export const PlasmicHoverableText__VariantProps = new Array<VariantPropType>(
  "above"
);

export type PlasmicHoverableText__ArgsType = {
  forceOverlay?: boolean;
  children?: React.ReactNode;
  popover?: React.ReactNode;
};
type ArgPropType = keyof PlasmicHoverableText__ArgsType;
export const PlasmicHoverableText__ArgProps = new Array<ArgPropType>(
  "forceOverlay",
  "children",
  "popover"
);

export type PlasmicHoverableText__OverridesType = {
  tooltip?: Flex__<typeof Tooltip>;
  dottedUnderlineBorder?: Flex__<"div">;
};

export interface DefaultHoverableTextProps {
  forceOverlay?: boolean;
  children?: React.ReactNode;
  popover?: React.ReactNode;
  above?: SingleBooleanChoiceArg<"above">;
  className?: string;
}

const $$ = {};

function PlasmicHoverableText__RenderFunc(props: {
  variants: PlasmicHoverableText__VariantsArgs;
  args: PlasmicHoverableText__ArgsType;
  overrides: PlasmicHoverableText__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          forceOverlay: false,
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "above",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.above,
      },
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <Tooltip
      data-plasmic-name={"tooltip"}
      data-plasmic-override={overrides.tooltip}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames("__wab_instance", sty.tooltip)}
      content={renderPlasmicSlot({
        defaultContents: (
          <div className={classNames("all", "__wab_text", sty.text___26Bq)}>
            {"Some description"}
          </div>
        ),
        value: args.popover,
      })}
      showArrow={true}
      trigger={
        <div
          data-plasmic-name={"dottedUnderlineBorder"}
          data-plasmic-override={overrides.dottedUnderlineBorder}
          className={classNames("all", sty.dottedUnderlineBorder, {
            [sty.dottedUnderlineBorderglobal_environment_website]: hasVariant(
              globalVariants,
              "environment",
              "website"
            ),
          })}
        >
          {renderPlasmicSlot({
            defaultContents: "4 collaborators",
            value: args.children,
            className: classNames(sty.slotTargetChildren),
          })}
        </div>
      }
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  tooltip: ["tooltip", "dottedUnderlineBorder"],
  dottedUnderlineBorder: ["dottedUnderlineBorder"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  tooltip: typeof Tooltip;
  dottedUnderlineBorder: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHoverableText__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHoverableText__VariantsArgs;
    args?: PlasmicHoverableText__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicHoverableText__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHoverableText__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHoverableText__ArgProps,
          internalVariantPropNames: PlasmicHoverableText__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicHoverableText__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "tooltip") {
    func.displayName = "PlasmicHoverableText";
  } else {
    func.displayName = `PlasmicHoverableText.${nodeName}`;
  }
  return func;
}

export const PlasmicHoverableText = Object.assign(
  // Top-level PlasmicHoverableText renders the root element
  makeNodeComponent("tooltip"),
  {
    // Helper components rendering sub-elements
    dottedUnderlineBorder: makeNodeComponent("dottedUnderlineBorder"),

    // Metadata about props expected for PlasmicHoverableText
    internalVariantProps: PlasmicHoverableText__VariantProps,
    internalArgProps: PlasmicHoverableText__ArgProps,
  }
);

export default PlasmicHoverableText;
/* prettier-ignore-end */
